// Payment status chip (§10.2): Success green, Processing amber, Failed red.
import type { PaymentStatus } from '@/types/phase2.types';
import '../pay.css';

const CONFIG: Record<PaymentStatus, { className: string; label: string }> = {
  SUCCESS: { className: 'nova-pay-chip-ok', label: 'Success' },
  PENDING: { className: 'nova-pay-chip-warn', label: 'Processing' },
  FAILED: { className: 'nova-pay-chip-bad', label: 'Failed' },
  PENDING_APPROVAL: { className: 'nova-pay-chip-warn', label: 'Awaiting approval' },
  APPROVED: { className: 'nova-pay-chip-ok', label: 'Approved' },
  REJECTED: { className: 'nova-pay-chip-bad', label: 'Rejected' },
  CANCELLED: { className: 'nova-pay-chip-bad', label: 'Cancelled' },
};

const PaymentStatusChip = ({ status }: { status: PaymentStatus }) => {
  const config = CONFIG[status] ?? { className: 'nova-pay-chip-warn', label: 'Unknown status' };
  return <span className={`nova-pay-chip ${config.className}`}>{config.label}</span>;
};

export default PaymentStatusChip;
